import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { AuthService } from "src/app/auth-section/auth-service/auth.service";
import { DoctorsService } from "../../doctor-service/doctors.service";
import { DocLocalService } from "../../doctor-service/doc-local.service";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { MessageService } from "primeng/api";
import { ConfirmationService } from "primeng/api";
import { UrlModal } from '../../../../app/shared/url.model';

import {
  FormGroup,
  FormControlName,
  Validators,
  FormControl,
} from "@angular/forms";
import { AppointmentService } from "src/app/appointment-section/appointment-service/appointment.service";
import { take } from "rxjs/operators";

@Component({
  selector: "app-singledoctor",
  templateUrl: "./singledoctor.component.html",
  styleUrls: ["./singledoctor.component.css"],
  providers: [MessageService, ConfirmationService],
})
export class SingledoctorComponent implements OnInit {
  token: string;
  isData: boolean = false;
  docData;
  startTime = null;

  endTime = null;
  getappointmentDate: string;
  id: any;
  patNum = 0;
  patientNumber = 0;
  date4: Date = null;
  patLimit = 0;
  isAppointment: boolean = false;
  patId: string;
  patForm: FormGroup;
  isAppointmentEnable = false;
  maxDate: Date;
  minDate: Date;
  isActive = false;
  invalidDates: Date[];
  clinicArray = [];
  editClinicForm :FormGroup;
  addLedForm:FormGroup;
  addledData:any;
  selectClinicId:any;
  tokenBookingTimeArr = [];
  addLedSuccessFlag=false;
  selectedDpFile: File = null;
  ledList:any;
  UrlModal:UrlModal
  @ViewChild("calendar", { static: true })
  @ViewChild ('closeeditClinic',{static:false}) closeEditClinicModal:ElementRef;
  calendar: any;
  constructor(
    private authService: AuthService,
    private docService: DoctorsService,
    private docLocalService: DocLocalService,
    private activatedRoute: ActivatedRoute,
    private appointmentService: AppointmentService,
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit() {
    this.setClinicTime();
    this.id = this.activatedRoute.snapshot.queryParams["id"];

    this.authService.authDataSubject.pipe(take(1)).subscribe((res) => {
      this.token = res._token;
    });

    this.getSingleDoctor();

    if (this.isAppointment) {
      // this.getAppointment();
    }

    this.onInitForm();
  }
  getSingleDoctor() {
    this.docService
      .getSingleDoctorFromDb(this.id, this.token)
      .subscribe((res) => {
        this.docData = res;
        this.clinicArray = res.clinicId;
        this.onInitForm();
      });
  }
  onInitForm() {
    this.patForm = new FormGroup({
      patientLimit: new FormControl(this.patLimit, Validators.required),
    });
    this.editClinicForm = new FormGroup ({
      patLimit:new FormControl (null,Validators.required),
      skipDays:new FormControl (null,Validators.required),
      consFee: new FormControl (null,Validators.required),
      isPayAble: new FormControl (null,Validators.required),
      bookingType: new FormControl (null,Validators.required),
      forAttending: new FormControl (null,Validators.required),
      emergencyApptAble: new FormControl(null,Validators.required) ,
      startTime: new FormControl(null,Validators.required),
      endTime : new FormControl(null,Validators.required)
    });
    this.addLedForm = new FormGroup({
      doctorId: new FormControl(null),
      clinicId: new FormControl(null,Validators.required),
      pass: new FormControl(null,Validators.required),
      ssid: new FormControl(null,Validators.required)
    })
  }
  onEditClinic(index:any){
    console.log("this is index",index);
    console.log("this is clinic",this.clinicArray[index]);
    console.log("skipDays",this.clinicArray[index].skipDays);
     this.selectClinicId = this.clinicArray[index]._id;
    this.editClinicForm = new FormGroup ({
      patLimit:new FormControl (this.clinicArray[index].patientLimit,Validators.required),
      consFee: new FormControl (this.clinicArray[index].amount,Validators.required),
      skipDays:new FormControl (this.clinicArray[index].skipDays,Validators.required),
      isPayAble: new FormControl (this.clinicArray[index].isPayAble,Validators.required),
      bookingType: new FormControl (this.clinicArray[index].bookingType,Validators.required),
      forAttending: new FormControl (this.clinicArray[index].forAttending,Validators.required),
      emergencyApptAble: new FormControl(this.clinicArray[index].EmergencyApptAble,Validators.required),
      startTime: new FormControl((this.clinicArray[index].timming && this.clinicArray[index].timming.startTime)?this.clinicArray[index].timming.startTime:"",Validators.required),
      endTime : new FormControl((this.clinicArray[index].timming && this.clinicArray[index].timming.endTime)?this.clinicArray[index].timming.endTime:"",Validators.required)
    });
    console.log("this is editclinicForm valid ===>>>",this.editClinicForm.valid);
    this.tokenBookingTimeArr = this.clinicArray[index].tokenBookingTime;
    console.log("this is tokenBookingTime ==>>>",this.tokenBookingTimeArr);
  }
  onUpdateclinic(){
    console.log("this is tokenBookingTime",this.tokenBookingTimeArr);
    let payload = {...this.editClinicForm.value,...{tokenBookingTime:this.tokenBookingTimeArr}};
    console.log("this is final postData",payload);
    
    this.docService.editClinicById(this.selectClinicId,payload,this.token).subscribe((res:any)=>{
      console.log("this is response ",res);
      this.closeEditClinicModal.nativeElement.click();
      alert("success");
      this.getSingleDoctor();
    },(err)=>{
      alert(err.status)
    })
  }

  onDpSelected(event: any) {
  const file = event.target.files[0];
  if (file) {
    this.selectedDpFile = file;

    // Optional: Local preview (updates the UI before upload)
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.docData.image = e.target.result;
    };
    reader.readAsDataURL(file);
  }
}

uploadDoctorDp() {
  if (!this.selectedDpFile) return;

  const formData = new FormData();
  // Using docData?._id ensures we are uploading for the correct doctor
  formData.append('doctorDp', this.selectedDpFile);
  formData.append('doctorId', this.docData._id);

  // Use your existing doctor service
  this.docService.uploadDp(formData, this.token).subscribe(
    (res: any) => {
      this.selectedDpFile = null;
      // Show success toast (using your PrimeNG toast)
      this.messageService.add({key: 'tc', severity:'success', summary: 'Success', detail: 'Profile Picture Updated'});
    },
    (err) => {
      console.error(err);
      alert("Failed to upload image");
    }
  );
}
  onAddLed(){
    let payload = this.addLedForm.value;
    payload.doctorId=this.id;
    console.log("this is payload",payload);
    
    this.docService.addLed(payload,this.token).subscribe((res:any)=>{
      console.log("this is response",res);
      this.addLedSuccessFlag = true;
      this.addledData = res.led;
    });
  }
  onChange(event){
    console.log(event.target.value);
    
  }
  onUpdateLimit() {
    console.log(this.patForm);
    const num = this.patForm.value["patientLimit"];
    this.docService.savePatientLimit(this.id, num, this.token);
  }
  getDocLeds(){
    this.docService.getLeds(this.id,this.token).subscribe((res:any)=>{
      this.ledList = res.leds;
    })
  }
  updateTokenBookingTimeArr(value,index,key){
    console.log("this is value on input",value.target.value,index,key);
    this.tokenBookingTimeArr[index][key] = value.target.value;
    console.log("this is tokenBookingTimeArr ==>>>",this.tokenBookingTimeArr);
    
  }
  addSlot(){
    let payload = {
      start : "12:00",
      end : "16:00"
    }
    this.tokenBookingTimeArr.push(payload);
    console.log("this is toekn",this.tokenBookingTimeArr);
  }
  removeSlot(index){
    this.tokenBookingTimeArr = this.tokenBookingTimeArr.filter((o,i)=>{
      if(i == index){
        return false;
      }else{
        return true;
      }
    })
  }
  /* onBookAppointment() {
    console.log(this.date4);

    var tomorrow = new Date();
    tomorrow.setDate(new Date().getDate() + 1);

    if (this.patientNumber < this.patLimit) {
      if (this.date4) {
        this.confirmationService.confirm({
          message: "Are you sure that you want to book the appointment?",
          accept: () => {
            this.bookApoointment("DAILY");
            //Actual logic to perform a confirmation
          },
        });
      } else {
        this.messageService.add({
          key: "tc",
          severity: "error",
          summary: "Appointment date cant be empty",
          detail: "Please select the appointent date",
        });
      }
    } else {
      this.confirmationService.confirm({
        message:
          "Appointment limit reached!! Do you want to book special appointment? ",
        accept: () => {
          this.bookApoointment("EMERGENCY");
        },

        /*  this.messageService.add({
        key: "tc",
        severity: "error",
        summary: "Appointment limit reached",
        detail: "Sorry Appointment limit of this doctor is reached"
      });
      });
    }
  }*/
  /*getClinicData() {
    this.docService.getClinicDetails(this.id, this.token).subscribe((res) => {
      if (res.status == 200) {
        this.patNum = res.data.patientNumber + 1;
        this.patLimit = res.data.patientLimit;
        this.isActive = res.data.isEnabled;
        console.log(this.isActive);
        this.patientNumber = res.data.patientNumber;
        if (this.patNum! > res.data.patientLimit) {
          this.isAppointmentEnable = true;
        }
      }
    });
  }*/
  /*getAppointment() {
    const tommarowDate = new Date();
    tommarowDate.setDate(tommarowDate.getDate() + 1);
    const appointmentDate = moment(tommarowDate)
      .format()
      .split("T")[0];
    console.log(appointmentDate);
    this.appointmentService
      .getPatientAppointment(this.patId, this.id, appointmentDate, this.token)
      .subscribe(res => {
        this.getappointmentDate = res.appointmentDate.toString().split("T")[0];
        console.log(this.getappointmentDate);
      });
  }*/

  /* intilizeCalender() {
    this.maxDate = new Date();
    this.maxDate.setDate(this.maxDate.getDate() + 1);
    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate() + 1);
  }*/

  onSeeAppointment() {
    this.router.navigate(["../", "appointments"], {
      relativeTo: this.activatedRoute,
      preserveQueryParams: true,
    });
  }
  /* onActiveButton() {
    this.docService
      .setDoctorStatus(this.id, this.isActive, this.token)
      .subscribe((res) => {});
  }

  bookApoointment(status: string) {
    const jDate = moment(this.date4).format();
    console.log(jDate);
    const tdate = jDate.split("T")[0];

    if (tdate !== this.getappointmentDate) {
      this.docService
        .savePatientNumber(this.id, this.patNum, this.token)
        .subscribe((res) => {
          this.patientNumber += 1;
        });

      this.appointmentService
        .saveAppointment(
          this.id,
          this.patNum,
          this.patId,
          this.token,
          tdate,
          status
        )
        .subscribe((res) => {
          this.getappointmentDate = tdate;
          this.messageService.add({
            key: "tc",
            severity: "success",
            summary: "Appointment booked",
            detail: "Appointment booked successfully ",
          });
        });
    } else {
      this.messageService.add({
        key: "tc",
        severity: "error",
        summary: "Appointment of this date already booked",
        detail: "Appointment of this patient for this day is already there ",
      });
    }
  }*/

  setClinicTime() {
    const date = new Date();
    console.log(date.toTimeString());
  }

  OnSetClinicTime() {
    if (this.startTime && this.endTime) {
      const st = new Date(this.startTime);
      console.log();
      this.docService
        .setClinicTiming(this.startTime, this.endTime, this.id, this.token)
        .subscribe((res) => {
          console.log(res);
        });
    }
  }
}
/*




address: {city: "NAJIBABAD", district: "NAJIBABAD", line1: "#Sco 123", pincode: 246763, state: "UP"}
city: "NAJIBABAD"
district: "NAJIBABAD"
line1: "#Sco 123"
pincode: 246763
state: "UP"
appointmentNumber: 0
clinicImages: ["uploads/clinicImage/pexels-photo-356040.jpeg", "uploads/clinicImage/pexels-photo-208474.jpeg",…]
0: "uploads/clinicImage/pexels-photo-356040.jpeg"
1: "uploads/clinicImage/pexels-photo-208474.jpeg"
2: "uploads/clinicImage/medical-appointment-doctor-healthcare-40568.jpeg"
clinicImagesThumbnail: ["uploads/clinicImage/thumbnail-pexels-photo-356040.jpeg",…]
0: "uploads/clinicImage/thumbnail-pexels-photo-356040.jpeg"
1: "uploads/clinicImage/thumbnail-pexels-photo-208474.jpeg"
2: "uploads/clinicImage/thumbnail-medical-appointment-doctor-healthcare-40568.jpeg"
clinicName: "HealthCure"
createdAt: "2020-08-31T12:11:14.168Z"
doctorId: "5f4ce8e272d22907bab83393"
emergencyPatientLimit: 0
isDeleted: false
isEmergencySlotOpened: false
isEnabled: false
patientLimit: 120
patientNumber: 0










*/
